/**
 * AnnotationControls Component
 * 
 * Toolbar component for annotation list controls including:
 * - Unreviewed filter toggle
 * - Reviewer tools toggle
 * - Details toggle
 * - Bulk edit mode toggle
 * - Auto-scroll toggle
 */
import React, { memo } from 'react';
import {
    View,
    Button,
    Checkbox,
    Flex,
    IamProtected,
} from '@smarterservices/smarter-ui';
import { NavigationalToolTip } from '@ui/shared/components/Common/NavigationalToolTip';
import CONSTANTS from '../../../config/constants';

const AnnotationControls = memo(({
    showUnreviewed,
    showReviewerTools,
    showDetails,
    bulkEdit,
    autoScrollEnabled,
    onUnreviewedToggle,
    onReviewerToolsToggle,
    onDetailsToggle,
    onBulkEditToggle,
    onAutoScrollToggle,
    sessionSid,
    getIamResourceString,
    controlsRef,
}) => {
    return (
        <View
            as="div"
            className="auto-scroll-toggle"
            background="primary"
            elementRef={(ref) => {
                if (controlsRef) {
                    controlsRef.current = ref;
                }
            }}
        >
            <View
                as="div"
                background="secondary"
                borderColor="primary"
                borderRadius="medium"
                borderWidth="small"
                padding="x-small"
                margin="none none xx-small none"
            >
                <Flex justifyItems="space-between" alignItems="center">
                    <Flex.Item>
                        <IamProtected
                            description="Protects the reviewer toggles for annotations."
                            permissionsOr={[
                                {
                                    action: 'sp:ModifyExamAnnotation',
                                    resource: getIamResourceString(`session/${sessionSid}`)
                                },
                                {
                                    action: 'sp:DeleteExamAnnotation',
                                    resource: getIamResourceString(`session/${sessionSid}`)
                                }
                            ]}
                        >
                            <NavigationalToolTip
                                description="Only show the unreviewed annotations"
                                placement="bottom start"
                                shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.ANNOTATIONS?.OPTIONS?.ONLY_UNREVIEWED_TOGGGLE?.KEY}
                            >
                                <Checkbox
                                    label="Unreviewed"
                                    variant="toggle"
                                    size="small"
                                    labelPlacement="end"
                                    checked={showUnreviewed}
                                    onChange={onUnreviewedToggle}
                                    inline
                                />
                            </NavigationalToolTip>
                            {/* 
                            <View padding="none none none small">
                                <NavigationalToolTip
                                    description="Toggle reviewer tools"
                                    placement="bottom start"
                                    shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.ANNOTATIONS?.OPTIONS?.SHOW_REVIEWER_TOOLS?.KEY}
                                >
                                    <Checkbox
                                        label="Tools"
                                        variant="toggle"
                                        size="small"
                                        labelPlacement="end"
                                        checked={showReviewerTools}
                                        onChange={onReviewerToolsToggle}
                                        inline
                                    />
                                </NavigationalToolTip>
                            </View>
                            */}
                        </IamProtected>
                        {/*
                        <View padding="none none none x-small">
                            <NavigationalToolTip
                                description="Auto scroll"
                                placement="bottom start"
                                shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.ANNOTATIONS?.OPTIONS?.AUTO_SCROLL?.KEY}
                            >
                                <Checkbox
                                    label="Auto Scroll"
                                    variant="toggle"
                                    size="small"
                                    inline={true}
                                    labelPlacement="end"
                                    checked={autoScrollEnabled}
                                    onChange={onAutoScrollToggle}
                                    margin="none none none x-small"
                                />
                            </NavigationalToolTip>
                        </View>
                        
                        <View padding="none none none small">
                            <NavigationalToolTip
                                description="Toggle annotation details"
                                placement="bottom start"
                                shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.ANNOTATIONS?.OPTIONS?.SHOW_DETAILS?.KEY}
                            >
                                <Checkbox
                                    label="Details"
                                    variant="toggle"
                                    size="small"
                                    labelPlacement="end"
                                    checked={showDetails}
                                    onChange={onDetailsToggle}
                                    inline
                                />
                            </NavigationalToolTip>
                        </View>
                         */}
                    </Flex.Item>
                    <Flex.Item>
                        <IamProtected
                            permissionsOr={[
                                {
                                    action: 'sp:ModifyExamAnnotation',
                                    resource: getIamResourceString(`session/${sessionSid}`)
                                },
                                {
                                    action: 'sp:DeleteExamAnnotation',
                                    resource: getIamResourceString(`session/${sessionSid}`)
                                }
                            ]}
                        >
                            {!bulkEdit && (
                                <NavigationalToolTip
                                    description="Bulk edit annotations"
                                    shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.ANNOTATIONS?.OPTIONS?.BULK_EDIT?.KEY}
                                >
                                    <Button
                                        size="small"
                                        screenReaderLabel={bulkEdit ? "Disable bulk edit" : "Enable bulk edit"}
                                        onClick={onBulkEditToggle}
                                        color={bulkEdit ? "success" : "primary"}
                                        style={{
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            backdropFilter: 'blur(4px)',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                            border: '1px solid rgba(0, 0, 0, 0.1)'
                                        }}
                                    >
                                        Bulk Edit
                                    </Button>
                                </NavigationalToolTip>
                            )}
                        </IamProtected>

                    </Flex.Item>
                </Flex>
            </View>
        </View>
    );
});

AnnotationControls.displayName = 'AnnotationControls';

export default AnnotationControls;
